import process01 from "../assets/images/data-image/process-01.jpg";
import process02 from "../assets/images/data-image/process-02.jpg";
import process03 from "../assets/images/data-image/process-03.jpg";
import process04 from "../assets/images/data-image/process-07.jpg";
import process05 from "../assets/images/data-image/process-06.jpg";
import process06 from "../assets/images/data-image/process-05.jpg";

const processSteps = [
  {
    id: 1,
    title: "Raw Material Selection",
    description:
      "Quality cement, graded aggregates, clean water, and reinforcement materials are carefully selected to produce strong and durable RCC Hume Pipes.",
    image: process01,
  },
  {
    id: 2,
    title: "Reinforcement Cage Preparation",
    description:
      "Steel reinforcement is accurately prepared and positioned to provide the required structural strength and durability inside the concrete pipe.",
    image: process02,
  },
  {
    id: 3,
    title: "Mould Assembly",
    description:
      "The reinforcement cage is placed inside precision pipe moulds, ensuring the correct diameter, wall thickness, and shape of the finished Hume Pipe.",
    image: process03,
  },
  {
    id: 4,
    title: "Concrete Mixing & Compaction",
    description:
      "A carefully proportioned concrete mix is placed into the mould and compacted to achieve uniform density, strength, and a smooth pipe structure.",
    image: process04,
  },
  {
    id: 5,
    title: "Curing Process",
    description:
      "The manufactured RCC pipes undergo controlled curing to develop the required concrete strength, durability, and long-term performance.",
    image: process05,
  },
  {
    id: 6,
    title: "Quality Inspection & Dispatch",
    description:
      "Each finished Hume Pipe is inspected for dimensional accuracy, surface quality, and overall manufacturing standards before being prepared for delivery.",
    image: process06,
  },
];

export default processSteps;